module.exports = __webpack_public_path__ + "static/media/ensembles_title.5fe46983.png";